import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/builds/sbt/smsbat/layouts/default.vue").then(m => m.default || m))
}